<template>
    <div>
        <div v-if="$store.state.settings.mode ==='pc'" class="main">
            <div class="container">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item v-for="(item, index) in policyList12" :key="index" :to="{name: item.routerLink}">{{ item.name }}</el-breadcrumb-item>
                </el-breadcrumb>
                <div class="certificateInquiry">
                    <div class="title">证件查询</div>
                    <div class="form">
                        <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" class="demo-ruleForm">
                            <el-form-item label="姓 名" prop="username" style="width: 490px;">
                                <el-input v-model="ruleForm.username" placeholder="请输入姓名" />
                            </el-form-item>
                            <el-form-item label="身份证号" prop="idCard" style="width: 490px;">
                                <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号" />
                            </el-form-item>
                            <el-form-item label="证件编号" prop="certCode" style="width: 490px;">
                                <el-input v-model.number="ruleForm.certCode" placeholder="请输入证件编号" />
                            </el-form-item>
                            <el-form-item label="验 证 码" prop="captcha" style="width: 490px;">
                                <!-- <el-input v-model.number="ruleForm.yzm" /> -->
                                <div class="flexbox">
                                    <el-input
                                        v-model="ruleForm.captcha"
                                        style="width: 230px;"
                                        placeholder="请输入验证码"
                                        @keyup.enter.native="handleLogin"
                                    />
                                    <!-- <img
                                    :src="`${baseURL}/captcha/image`"
                                > -->
                                    <img
                                        :src="`${baseURL}/captcha/image?${num}`"
                                        @click="changeImg"
                                    >
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="btn1" @click="submitForm('ruleForm')">点击查询</el-button>
                                <el-button class="btn2" @click="resetForm('ruleForm')">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$store.state.settings.mode ==='mobile'" class="mobileMain">
            <div class="head">
                <img src="../../assets/images/index/zjt.png" alt="" @click="fallback">
                <div>证件查询</div>
            </div>
            <div class="certificateInquiry">
                <div class="form">
                    <el-form ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="80px" class="demo-ruleForm">
                        <el-form-item label="姓 名" prop="username">
                            <el-input v-model="ruleForm.username" placeholder="请输入姓名" />
                        </el-form-item>
                        <el-form-item label="身份证号" prop="idCard">
                            <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号" />
                        </el-form-item>
                        <el-form-item label="证件编号" prop="certCode">
                            <el-input v-model.number="ruleForm.certCode" placeholder="请输入证件编号" />
                        </el-form-item>
                        <el-form-item label="验 证 码" prop="captcha">
                            <div class="flexbox">
                                <el-input
                                    v-model="ruleForm.captcha"
                                    style="width: 200px;"
                                    placeholder="请输入验证码"
                                    @keyup.enter.native="handleLogin"
                                />
                                <img
                                    :src="`${baseURL}/captcha/image?${num}`"
                                    @click="changeImg"
                                >
                            </div>
                        </el-form-item>
                    </el-form>
                    <div class="btn">
                        <el-button class="search" @click="submitForm('ruleForm')">点击查询</el-button>
                        <el-button class="reset" @click="resetForm('ruleForm')">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        // var checkAge = (rule, value, callback) => {
        //     if (!value) {
        //         return callback(new Error('年龄不能为空'))
        //     }
        //     setTimeout(() => {
        //         if (!Number.isInteger(value)) {
        //             callback(new Error('请输入数字值'))
        //         } else {
        //             if (value < 18) {
        //                 callback(new Error('必须年满18岁'))
        //             } else {
        //                 callback()
        //             }
        //         }
        //     }, 1000)
        // }
        return {
            baseURL: process.env.VUE_APP_API_ROOT,
            policyList12: [
                {
                    name: '首页',
                    routerLink: 'index'
                },
                {
                    name: '证件查询'
                }
            ],
            ruleForm: {
                username: '',
                idCard: '',
                certCode: '',
                captcha: '',
                sessionId: this.$cookies.get('PHPSESSID')
            },
            imgurl: '',
            num: 1,
            rules: {
                username: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                certCode: [
                    { required: true, message: '请输入证件编号', trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.changeImg()
        console.log(this.$cookies.keys())
        console.log('9999=>', this.$cookies.get('PHPSESSID'))
    },
    methods: {
        // 验证码
        changeImg() {
            this.num += 1
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    console.log(this.ruleForm)
                    this.$api.post('certificate/search', this.ruleForm)
                        .then(res => {
                            console.log('resssss', res)
                            this.$router.push({
                                name: 'queryResults',
                                query: {
                                    data: res.data
                                }
                            })

                        })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        fallback() {
            this.$router.go(-1)
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        }
    }

}

</script>

<style lang="scss" scoped>
h1 {
    width: 100px;
}
.main {
    background: #f4f5f7;
    padding-bottom: 30px;
    .flexbox {
        display: flex;
        img {
            width: 130px;
            margin-left: 15px;
        }
    }
    .container {
        width: 1200px;
        margin: 0 auto;
        padding-top: 30px;
        span {
            font-size: 16px;
            font-weight: 400 !important;
            color: #999 !important;
            line-height: 50px;
            cursor: pointer;
            display: block;
            -moz-user-select: none; /* 火狐 */
            -webkit-user-select: none; /* webkit浏览器 */
            -ms-user-select: none; /* IE10 */
            -khtml-user-select: none; /* 早期浏览器 */
        }
        ul {
            list-style: none;
            width: 280px;
            display: flex;
            justify-content: space-between;
            padding-left: 0;
            li {
                font-size: 16px;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 30px;
                cursor: pointer;
                -moz-user-select: none; /* 火狐 */
                -webkit-user-select: none; /* webkit浏览器 */
                -ms-user-select: none; /* IE10 */
                -khtml-user-select: none; /* 早期浏览器 */
                padding-left: 4px;
                &:last-child {
                    font-size: 16px;
                    font-weight: 400;
                    color: #333;
                    line-height: 30px;
                }
            }
        }
        .zcfg {
            width: 200px;
        }
        .contact-name {
            font-size: 30px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            width: 100%;
            display: block;
            text-align: center;
            margin-top: 50px;
            margin-bottom: 10px;
        }
        .contact-name-e {
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 30px;
            width: 100%;
            display: block;
            text-align: center;
        }
    }
    .certificateInquiry {
        background: #fff;
        text-align: center;
        padding: 60px 0 80px 0;
        .title {
            font-size: 20px;
            font-weight: 600;
            color: #243db3;
            padding-bottom: 40px;
        }
        .form {
            display: flex;
            justify-content: center;
            font-size: 16px;
            font-weight: 400;
            .el-form-item__content {
                margin-left: 50px;
                margin-top: 8px;
            }
            .el-button {
                width: 163px;
                height: 48px;
            }
            .btn1 {
                background: #243db3;
                color: #fff;
            }
            .btn2 {
                background: #f4f5f7;
                border: 1px solid #eee;
                color: #000;
            }
        }
    }
    ::v-deep .el-breadcrumb__inner {
        font-size: 16px;
        font-weight: 400 !important;
        color: #999 !important;
        line-height: 30px;
    }
}
.mobileMain {//移动端样式
    .head {
        height: 60px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        img {
            width: 10px;
            height: 16px;
        }
        div {
            flex: 1;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            color: #000;
        }
    }
    .form {
        width: calc(100% - 30px);
        padding: 30px 15px 0;
        .flexbox {
            display: flex;
            img {
                width: 114px;
                margin-left: 15px;
            }
        }
    }
    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        .search {
            width: 100px;
            height: 40px;
            background: #eee;
            color: #000;
        }
        .reset {
            width: 100px;
            height: 40px;
            background: #243db3;
            color: #fff;
            margin-left: 30px;
        }
    }
}
</style>
